import { Component } from '@angular/core';

@Component({
  selector: 'app-report-icon',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 17 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M5.72461 9.5H9.72461V10.5H5.72461V9.5ZM5.72461 7H11.7246V8H5.72461V7ZM5.72461 12H8.22461V13H5.72461V12Z"
    fill="#000"
  />
  <path
    d="M13.2246 3H11.7246V2.5C11.7246 2.23478 11.6193 1.98043 11.4317 1.79289C11.2442 1.60536 10.9898 1.5 10.7246 1.5H6.72461C6.45939 1.5 6.20504 1.60536 6.0175 1.79289C5.82997 1.98043 5.72461 2.23478 5.72461 2.5V3H4.22461C3.95939 3 3.70504 3.10536 3.5175 3.29289C3.32997 3.48043 3.22461 3.73478 3.22461 4V14.5C3.22461 14.7652 3.32997 15.0196 3.5175 15.2071C3.70504 15.3946 3.95939 15.5 4.22461 15.5H13.2246C13.4898 15.5 13.7442 15.3946 13.9317 15.2071C14.1193 15.0196 14.2246 14.7652 14.2246 14.5V4C14.2246 3.73478 14.1193 3.48043 13.9317 3.29289C13.7442 3.10536 13.4898 3 13.2246 3ZM6.72461 2.5H10.7246V4.5H6.72461V2.5ZM13.2246 14.5H4.22461V4H5.72461V5.5H11.7246V4H13.2246V14.5Z"
    fill="#000"
  />
</svg>
`
})
export class ReportIconComponent {}
